<template>
  <base-select
    :model-value="modelValue"
    :options="availableBanks"
    :placeholder="$t('WithdrawToCard | selectBankPlaceholder')"
    @update:modelValue="handleSelectBank"
  >
    <template #trigger>
      <template v-if="selectedBankDescription">
        <span class="text">{{ $t(selectedBankDescription.title) }}</span>
      </template>
      <template v-else>
        {{ $t('WithdrawToCard | selectBankPlaceholder') }}
      </template>
    </template>

    <template #item="{ data }">
      <span class="text">{{ $t(data.title) }}</span>
    </template>
  </base-select>
</template>

<script>
import BaseSelect from '@emcd-shared/base-select/ui'

export default {
  name: 'SelectBank',

  props: {
    // Selected bank
    modelValue: {
      required: true,
    },
    // All available banks
    options: {
      type: Object,
    },
  },

  emits: ['update:modelValue'],

  components: {
    BaseSelect,
  },

  computed: {
    // Return array of all available banks
    availableBanks() {
      if (!this.options) return []

      return Object.values(this.options).map((option) => ({
        ...option,
        optionValue: option.value, // BaseSelect expects optionValue
      }))
    },

    // Object with description of the selected bank
    selectedBankDescription() {
      return this.availableBanks.find((bank) => bank.value === this.modelValue)
    },
  },

  methods: {
    handleSelectBank(value) {
      this.$emit('update:modelValue', value)
    },
  },
}
</script>
